import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, Collapse } from '@as/cotopaxi';
import { AemComponentType } from '@as-react/common-types';
import { Box } from '@yonderland/andes-react';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { AemComponent } from '../common/aem-component/AemComponent';
import { CollapsibleListLD } from './collapsible-list-ld/CollapsibleListLD';
const CollapsibleList = props => {
    const dispatch = useDispatch();
    const handleCollapsibleItemClick = (id, isOpen) => {
        const items = props[':items'];
        const itemId = Object.entries(items).find(([_, values]) => values.id === id);
        if (isOpen && itemId) {
            dispatch(analyticsActions.faqQuestionExpand(items[itemId[0]].title));
        }
    };
    return (_jsxs(_Fragment, { children: [props.structuredData === 'faq' && _jsx(CollapsibleListLD, Object.assign({}, props)), _jsx(Accordion, { onItemClick: handleCollapsibleItemClick, children: props[':itemsOrder'].map((collapsibleListItem) => {
                    const listItem = props[':items'][collapsibleListItem];
                    if (!Object.values(AemComponentType).includes(listItem[':type'])) {
                        return null;
                    }
                    return (_jsx(Collapse, { id: listItem.id, title: listItem.title, withHover: true, children: _jsx(Box, { paddingBlock: "4", children: listItem[':itemsOrder'].map((collapsibleListItemComponent) => (_jsx(AemComponent, Object.assign({}, listItem[':items'][collapsibleListItemComponent]), `${listItem.id}-${collapsibleListItemComponent}`))) }) }, listItem.id));
                }) })] }));
};
export default CollapsibleList;
